import { render, staticRenderFns } from "./DoveSiamo.vue?vue&type=template&id=b5d5ba9a"
import script from "./DoveSiamo.vue?vue&type=script&lang=js"
export * from "./DoveSiamo.vue?vue&type=script&lang=js"
import style0 from "./DoveSiamo.vue?vue&type=style&index=0&id=b5d5ba9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports